import { CateringFoodTypeQuery } from 'components/pages/CateringFoodTypePage/types/query'
import TruckCard from 'components/TruckCard'
import pathFromUrl from 'utils/pathFromUrl'
import React from 'react'

type Props = {
  trucks: NonNullable<CateringFoodTypeQuery['foodTypePage']>['trucks']
  marketName?: string
  cuisineType: string
}
const TruckList = ({ trucks, marketName, cuisineType }: Props) => {
  if (trucks.length === 0) return null
  return (
    <div className="pt-4 lg:pt-10 pb-16 bg-gray-50">
      <div className="max-w-screen-lg mx-auto">
        <h2 className="text-3xl font-extrabold sm:text-4xl mt-8 mb-10 text-center">
          Best {cuisineType} Food Trucks{' '}
          {marketName && <span>in {marketName}</span>}
        </h2>
        <div className="sm:grid grid-cols-2">
          {trucks.map((t) => {
            return (
              <div key={t.id} className="col-span-1">
                <TruckCard
                  image={t.foodImage ? t.foodImage!.medium : t.image.medium}
                  name={t.name}
                  truckPath={pathFromUrl(t.scheduleUrl)}
                />
              </div>
            )
          })}
        </div>
        <div className="text-center mt-6 text-2xl text-gray-400 font-light">
          ...and more!
        </div>
      </div>
    </div>
  )
}

export default TruckList
